import { formatNumberToUSD } from "@features/utils/functions";
import classNames from "classnames";
import React from "react";

type UnlockBonusesCardContentProps = {
  isUk: boolean;
  timelockMinValue?: number;
  timeLockBalance?: number;
  small?: boolean;
  actions?: React.ReactNode;
};

export const UnlockBonusesCardContent = ({
  isUk,
  timelockMinValue,
  timeLockBalance,
  actions,
}: UnlockBonusesCardContentProps) => {
  const progressPercentage = Math.min(
    (timeLockBalance ?? 0 / Number(timelockMinValue)) * 100,
    100
  );

  return (
    <div className="tailwind text-sm">
      <div>
        Unlock&nbsp;{isUk ? "Features" : "bonuses"}&nbsp;by timelocking more
        than&nbsp;
        {formatNumberToUSD(timelockMinValue)} worth of ETH
      </div>

      <div className="flex justify-between items-end">
        <div
          className={classNames({
            "w-1/2 mt-4": !!actions,
            "w-full mt-8": !actions,
          })}
        >
          <div className="flex mb-2">
            {formatNumberToUSD(timeLockBalance ?? 0)} /{" "}
            <span className="text-[#E4E4E4]">
              {formatNumberToUSD(timelockMinValue)}
            </span>
          </div>
          <div className="w-full h-[8px] bg-[#E4E4E4] rounded-full">
            <div
              className="h-full bg-primary-regular rounded-full"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
        </div>

        {actions}
      </div>
    </div>
  );
};
